import { useSelector } from 'react-redux';
import { getHighlightSectors } from '../selectors';
import { IStore } from 'store/interface';
import { SectorColors } from '../utils';

export const useHighlightGameSectors = () =>
  useSelector<IStore, Record<SectorColors, boolean>>(getHighlightSectors);
